import axios from "axios";
import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static targets = ["form"];

  completeRegistration(event) {
    event.preventDefault();
    const form = this.formTarget,
      redirectUrl = this.data.get("redirectUrl");

    axios
      .patch(form.action, $(form).serialize())
      .then(response => {
        $(".card.card-signup").addClass("hidden");
        bootbox.alert({
          message: response.data.message,
          callback: function () {
            window.location = redirectUrl;
          },
          closeButton: false
        });
      })
      .catch(error => {
        showErrorMessage(error);
      });
  }
}
